import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async connect() {
    const images = await this.#loadImages()
    if (images.length === 0) return
    this.#displayImage()
  }

  async #loadImages() {
    const images = Array.from(this.element.querySelectorAll("img"))
    if (images.length === 0) return []
    await Promise.all(
      images.map(img => (img.decode ? img.decode().catch(() => {}) : Promise.resolve()))
    )
    return images
  }

  #displayImage() {
    this.element.classList.add("animate")
  }
}